import { MovimientoCuenta } from 'core/models/data/MovimientoCuenta';
import { Table } from 'shared/table';
import { formatDate, formatCurrency } from 'shared/utils';

export const AccountMovementsTable = (props: { tableContent: MovimientoCuenta[] }) => {
  return (
    <Table
      thead={
        <tr>
          <td>Fecha</td>
          <td>Tipo de transacción</td>
          <td>Importe</td>
          <td>Saldo</td>
        </tr>
      }
      tbody={
        <>
          {props.tableContent.map((item, index) => (
            <tr
              key={'movimiento-cuenta' + index}
              data-testid={'movimiento-cuenta-row-' + index}
            >
              <td>{formatDate(item.fechaMovimiento)}</td>
              <td className="align-left">{item.tipoMovimiento || ''}</td>
              <td className="align-right">{formatCurrency(item.importe)}</td>
              <td className="align-right">{formatCurrency(item.saldo)}</td>
            </tr>
          ))}
        </>
      }
    />
  );
};
